/**
 * 라이프사이클 4단계 wording — single source of truth (2026-05-18).
 *
 * 이전: app/trends/page.tsx + components/dashboard/LifecycleTabs.tsx 각자 정의 → 불일치.
 * 통일: 이 모듈 1곳만 수정하면 양쪽 자동 반영.
 */
import type { LifecycleStage } from "@/types";

export interface StageMeta {
  emoji: string;
  label: string;       // "태동기" 등
  title: string;       // "🌱 태동기"
  tip: string;         // 1줄 설명 (홈 카드 + /trends 둘 다 동일)
  cls: string;         // Tailwind bg/border 클래스
}

export const STAGE_META: Record<LifecycleStage, StageMeta> = {
  emerging: {
    emoji: "🌱",
    label: "태동기",
    title: "🌱 태동기",
    tip: "선점 기회 — 시장 형성 전, 신선한 키워드. 빨리 테스트해서 후발주자보다 먼저.",
    cls: "bg-green-500/10 border-green-500/30",
  },
  growing: {
    emoji: "🔥",
    label: "성장기",
    title: "🔥 성장기",
    tip: "도입 적기 — 최근 30일 + 1년 추세 모두 ↑. 정식 메뉴 도입 골든타임.",
    cls: "bg-orange-500/10 border-orange-500/30",
  },
  mature: {
    emoji: "📊",
    label: "성숙기",
    title: "📊 성숙기",
    tip: "안정기 — 시장 자리 잡은 검증 메뉴 (1년 추세 평탄). 시그니처·가격으로 차별화 시 안전.",
    cls: "bg-blue-500/10 border-blue-500/30",
  },
  declining: {
    emoji: "📉",
    label: "하락기",
    title: "📉 하락기",
    tip: "판매 끝물 — 신규 진입 비권장. 🫧 거품 단계 = 짧은 폭발 후 빠르게 식는 중 (특수 신호).",
    cls: "bg-gray-500/10 border-gray-500/30",
  },
};
